<div class="track-page-wrap w-screen h-screen flex items-center justify-center relative">
    <!-- <img src="../../../assets/images/track-bg.png" alt="Background Image" class="w-full h-full"> -->
    <div class="absolute inset-0 track-page-inner"></div>
    <div class="w-[450px] absolute z-1 track-page-inner-bg ml-auto rounded-[30px] lg:px-[3em] py-[6em] text-center">
        <h3 class="mb-0 text-[1em] text-black font-normal mt-0 welcome-text">Welcome to</h3>
        <img src="/assets/images/medease-logo.png" alt="" class="w-[200px] my-2">
        <!-- <h1 class="mt-2 mb-2 text-7xl text-[#677db9]">
            <span class="text-style font-bold">Med</span>
            <span class="font-thin">Ease</span>
        </h1> -->
        <h3 class="text-[#6eabc6] mt-0 mb-0 appointment-text">Medical Online Appointments</h3>
        <div class="mx-auto track-component-inner">
            <p class="text-[#2f4965] phone-text text-[1em] font-normal">Select Hospital and Continue</p>
            <form [formGroup]="searchForm">
                <section class="home-assistant" aria-labelledby="home-assistant-title">
                    <div class="assistant-title-row">
                        <mat-icon aria-hidden="true">auto_awesome</mat-icon>
                        <div>
                            <h4 id="home-assistant-title">Describe your appointment</h4>
                            <p>For example: I need to see a skin doctor tomorrow evening.</p>
                        </div>
                    </div>
                    <div class="assistant-input-row">
                        <mat-form-field class="w-full" appearance="outline">
                            <mat-label>What kind of appointment do you need?</mat-label>
                            <input matInput [(ngModel)]="aiMessage" [ngModelOptions]="{standalone: true}"
                                maxlength="1000" (keyup.enter)="askBookingAssistant()" [disabled]="aiLoading">
                        </mat-form-field>
                        <button mat-flat-button color="primary" type="button" (click)="askBookingAssistant()"
                            [disabled]="aiLoading || !aiMessage.trim()" aria-label="Ask appointment assistant">
                            <mat-icon>send</mat-icon>
                        </button>
                    </div>
                    <p class="assistant-loading" *ngIf="aiLoading">Understanding your appointment request...</p>
                    <p class="assistant-error" *ngIf="aiError" role="alert">{{ aiError }}</p>
                    <div class="assistant-result" *ngIf="aiReply">
                        <p>{{ aiReply }}</p>
                        <p *ngIf="aiSpecialty || aiDate || aiTimeOfDay" class="assistant-summary">
                            <span *ngIf="aiSpecialty">{{ aiSpecialty }}</span>
                            <span *ngIf="aiDate">{{ aiDate }}</span>
                            <span *ngIf="aiTimeOfDay">{{ aiTimeOfDay }}</span>
                        </p>
                    </div>
                </section>
                <!-- Branch Selection -->
                <div class="flex-1">
                    <mat-form-field class="w-full">
                        <mat-label>Hospitals</mat-label>
                        <mat-select formControlName="branches" (selectionChange)="onBranchSelectionChange($event.value)">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let branch of allBranches"
                                value="{{branch.id}}">{{branch.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="button-wrapper mt-4 mb-2">
                        <button mat-flat-button color="primary" type="button" class="gradient-btn" loadingButton
                            [loading]="isLoading" [disabled]="isLoading" (click)="continueToDoctors()">
                            <div class="flex items-center">
                                <img class="w-[15px] h-[15px] mr-3" src="/assets/images/track-icon.png" alt="image">
                                <span class="text-white">Continue</span>
                            </div>
                        </button>
                    </div>
                </div>
            </form>

        </div>
    </div>

    <!-- Mat Spinner  -->
    <ngx-spinner bdColor="rgba(0, 0, 0, 1)" size="default" color="#6eabc6" type="ball-spin-fade"
    [fullScreen]="true">
    <p style="color: #fff"> Fetching details... </p>
    </ngx-spinner>


    <!--Footer Menu-->
    <div class="absolute z-1 bottom-10 text-center">
        <div class="w-[150px] h-[40px] mx-auto">
            <img class="w-[100%] h-[100%] object-contain" src="/assets/images/medease-logo-white.png" alt="image">
        </div>
        <app-message></app-message>
        <app-footer-menu></app-footer-menu>
    </div>
</div>
